(() => {
  class DualSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.isAnimating = false;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-ds-slide]'));
      this.prevButtons = Array.from(this.querySelectorAll('[data-ds-prev]'));
      this.nextButtons = Array.from(this.querySelectorAll('[data-ds-next]'));
      this.liveRegion = this.querySelector('[data-ds-live]');
      this.totalSlides = this.slides.length;

      if (this.totalSlides <= 1) return;

      this.prevButtons.forEach((btn) =>
        btn.addEventListener('click', () => this.goToSlide(this.currentIndex - 1))
      );
      this.nextButtons.forEach((btn) =>
        btn.addEventListener('click', () => this.goToSlide(this.currentIndex + 1))
      );

      this.addEventListener('keydown', this.onKeydown.bind(this));
      this.updateArrowStates();
      this.handleVideos();

      if (Shopify && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e) => {
          const slide = e.target.closest('[data-ds-slide]');
          if (slide) {
            const index = parseInt(slide.getAttribute('data-ds-slide'), 10);
            this.goToSlide(index, false);
          }
        });
      }
    }

    goToSlide(index, animate = true) {
      if (this.isAnimating) return;
      if (index < 0 || index >= this.totalSlides) return;
      if (index === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[index];
      const direction = index > this.currentIndex ? 1 : -1;

      if (animate && !this.prefersReducedMotion()) {
        this.isAnimating = true;

        currentSlide.classList.add(
          'dual-slider__slide--exiting',
          direction > 0 ? 'dual-slider__slide--slide-out-left' : 'dual-slider__slide--slide-out-right'
        );
        currentSlide.classList.remove('dual-slider__slide--active');

        nextSlide.classList.add(
          'dual-slider__slide--entering',
          direction > 0 ? 'dual-slider__slide--slide-in-right' : 'dual-slider__slide--slide-in-left'
        );

        const onEnd = () => {
          currentSlide.classList.remove(
            'dual-slider__slide--exiting',
            'dual-slider__slide--slide-out-left',
            'dual-slider__slide--slide-out-right'
          );

          nextSlide.classList.remove(
            'dual-slider__slide--entering',
            'dual-slider__slide--slide-in-right',
            'dual-slider__slide--slide-in-left'
          );
          nextSlide.classList.add('dual-slider__slide--active');

          this.isAnimating = false;
        };

        nextSlide.addEventListener('animationend', onEnd, { once: true });
      } else {
        currentSlide.classList.remove('dual-slider__slide--active');
        nextSlide.classList.add('dual-slider__slide--active');
      }

      this.currentIndex = index;
      this.updateArrowStates();
      this.updateLiveRegion();
      this.handleVideos();
    }

    updateArrowStates() {
      this.prevButtons.forEach((btn) => {
        btn.disabled = this.currentIndex === 0;
      });
      this.nextButtons.forEach((btn) => {
        btn.disabled = this.currentIndex === this.totalSlides - 1;
      });
    }

    updateLiveRegion() {
      if (this.liveRegion) {
        this.liveRegion.textContent = `Slide ${this.currentIndex + 1} of ${this.totalSlides}`;
      }
    }

    handleVideos() {
      this.slides.forEach((slide, i) => {
        const video = slide.querySelector('[data-ds-video] video');
        if (!video) return;

        if (i === this.currentIndex) {
          video.play().catch(() => {});
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    }

    onKeydown(e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.goToSlide(this.currentIndex - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.goToSlide(this.currentIndex + 1);
      }
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
  }

  if (!customElements.get('dual-slider')) {
    customElements.define('dual-slider', DualSlider);
  }
})();